import { Box, TabItem, TabList, Tabs } from '@razorpay/blade/components';
import { routePaths } from 'components/Routes/data';
import React from 'react';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { compensationTabItems } from '../constants';
import RecurringDeductionsView from '../views/RecurringDeductionsView';
import CtcComponent from './CtcComponent';
import { useSearchParams } from 'hooks/useSearchParams';
import PerquisitesView from '../views/PerquisitesView';
import { FlexibleBenefitsView } from '../views/FlexibleBenefitsView';
import IsFeatureDisabledForRearch from 'access/IsFeatureDisabledForRearch';
import RestrictedRoute from 'components/Routes/RestrictedRoute';
import { useSelector } from 'react-redux';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';

export const CompensationBreakdown = () => {
  const location = useLocation();
  const history = useHistory();
  const currentTab = location.pathname.split('/')[3];
  const loggedInUserId = useSelector(loggedInUserSelectors.peopleId);
  const { urlParams } = useSearchParams();
  const peopleId = urlParams.get('userId');

  const handleTabChange = (value: string) => {
    const searchParams = peopleId ? `?userId=${peopleId}` : '';
    history.push({
      pathname:
        !peopleId || peopleId === loggedInUserId?.toString()
          ? `${routePaths.payDetails.compensation.myCompensation.root}/${value}`
          : `${routePaths.payDetails.compensation.root}/${value}`,
      search: searchParams,
    });
  };

  return (
    <>
      <Tabs
        variant="bordered"
        orientation="horizontal"
        size={'medium'}
        onChange={handleTabChange}
        defaultValue={compensationTabItems.ctc}
        value={currentTab}>
        <TabList>
          <TabItem value={compensationTabItems.ctc}>CTC Component</TabItem>
          <IsFeatureDisabledForRearch feature={['isRecurringDeductionsDisabled']}>
            <TabItem value={compensationTabItems.deductions}>Deductions</TabItem>
          </IsFeatureDisabledForRearch>
          <IsFeatureDisabledForRearch feature={['isPerquisiteDisabled']}>
            <TabItem value={compensationTabItems.perquisites}>Perquisites</TabItem>
          </IsFeatureDisabledForRearch>
          <IsFeatureDisabledForRearch feature={['isM3S2Disabled']}>
            <TabItem value={compensationTabItems.flexi}>Flexi Components</TabItem>
          </IsFeatureDisabledForRearch>
        </TabList>
      </Tabs>

      <Switch>
        <Route path={[routePaths.payDetails.compensation.root]} exact>
          <Redirect
            to={{
              pathname: routePaths.payDetails.compensation.ctc,
              search: peopleId ? `?userId=${peopleId}` : '',
            }}
          />
        </Route>
        <Route path={[routePaths.payDetails.compensation.myCompensation.root]} exact>
          <Redirect
            to={{
              pathname: routePaths.payDetails.compensation.myCompensation.ctc,
              search: peopleId ? `?userId=${peopleId}` : '',
            }}
          />
        </Route>
        <Route
          path={[
            routePaths.payDetails.compensation.ctc,
            routePaths.payDetails.compensation.myCompensation.ctc,
          ]}
          component={CtcComponent}
          exact
        />
        <RestrictedRoute
          path={[
            routePaths.payDetails.compensation.deductions,
            routePaths.payDetails.compensation.myCompensation.deductions,
          ]}
          exact
          component={RecurringDeductionsView}
          disabledFeaturesForRearch={['isRecurringDeductionsDisabled']}
        />
        <RestrictedRoute
          path={[
            routePaths.payDetails.compensation.perquisites,
            routePaths.payDetails.compensation.myCompensation.perquisites,
          ]}
          exact
          component={PerquisitesView}
          disabledFeaturesForRearch={['isPerquisiteDisabled']}
        />
        <RestrictedRoute
          path={[routePaths.payDetails.compensation.flexi, routePaths.payDetails.compensation.myCompensation.flexi]}
          exact
          component={FlexibleBenefitsView}
          disabledFeaturesForRearch={['isM3S2Disabled']}
        />
      </Switch>
      <Box marginBottom="spacing.8" />
    </>
  );
};
